module.exports = __webpack_public_path__ + "fonts/Prompt-MediumItalic.a1de5368.ttf";